document.addEventListener('live-pricing-done', () => {
/**
 * Creating the Assembly checkbox and adding it above the add to basket button
 */
  (() => {
    const actionsWrappers = document.querySelectorAll('.product-shopping-actions-addtocart');
    if (!actionsWrappers.length) return;

    // Checking for the assembly price
    const assemblyPriceElement = document.querySelector('.item-merchandising.chair-assembly .footer-wrapper-price .price-label');
    if (!assemblyPriceElement) return;

    const assemblyPrice = assemblyPriceElement.innerText;

    // Create the checkbox
    const assemblyCheckboxWrapper = document.createElement('div');
    assemblyCheckboxWrapper.classList.add('assembly-checkbox-wrapper');
    assemblyCheckboxWrapper.innerHTML = `
    <div class="icon-wrapper"></div>
    <div class="checkbox-group">
      <div class="form-group">
        <input type="checkbox" id="chair-assembly" name="chair-assembly">
        <label for="chair-assembly">
          Add Product Assembly for <span class="price">${assemblyPrice}</span>
        </label>
      </div>
    </div>
    <div class="tooltip-wrapper"></div>
  `;

    // Append the checkbox wrapper to each actions wrapper
    actionsWrappers.forEach((actionsWrapper) => {
      actionsWrapper.prepend(assemblyCheckboxWrapper.cloneNode(true));
    });
  })();

  /**
 * Adding the assembly product to cart
 */
  (() => {
    const assemblyCheckbox = document.getElementById('chair-assembly');
    if (!assemblyCheckbox) return;

    const assemblyProductCartButton = document.querySelector('.item-merchandising.chair-assembly .buttons.group .btn-add-to-cart');

    // Check the quantity of the main product and update the quantity of the assembly product
    const mainProductQuantity = document.querySelector('.product-shopping-actions-addtocart .buttons.group .qnt-count .inputquantity');
    const assemblyProductQuantity = document.querySelector('.item-merchandising.chair-assembly .buttons.group .inputquantity');

    // Checking if the user changes the number
    mainProductQuantity.addEventListener('change', () => {
      const newValue = mainProductQuantity.value;
      assemblyProductQuantity.value = newValue;
    });

    // Checking if the user changes with the + or - buttons
    const qtyButtons = document.querySelectorAll('.product-shopping-actions-row .buttons.group .qnt-count .incr-btn');

    if (qtyButtons.length !== 0) {
      qtyButtons.forEach((button) => {
        button.addEventListener('click', () => {
          let newValue = parseInt(mainProductQuantity.value, 10) + 1;
          if (button.textContent.includes('-')) {
            newValue = parseInt(mainProductQuantity.value, 10) - 1;
          }
          assemblyProductQuantity.value = newValue;
        });
      });
    }

    // Moving the modal directly to the body
    const assemblyModal = document.querySelector('.assembly-modal');
    if (!assemblyModal) return;

    const assemblyModalWrapper = document.createElement('div');
    assemblyModalWrapper.classList.add('assembly-modal-wrapper');
    assemblyModalWrapper.appendChild(assemblyModal);
    document.body.appendChild(assemblyModalWrapper);

    // Creating the modal overlay
    const assemblyModalOverlay = document.createElement('div');
    assemblyModalOverlay.classList.add('assembly-modal-overlay');
    document.body.appendChild(assemblyModalOverlay);

    // When clicking on the add to cart button, also trigger the click on the assembly product
    const mainProductCartButton = document.querySelector('.product-shopping-actions-addtocart .buttons.group .btn-add-to-cart');
    mainProductCartButton.addEventListener('click', (event) => {
      event.preventDefault();

      // If the checkbox is checked, trigger a click on the add to cart button of asembly product
      if (assemblyCheckbox.checked) {
        assemblyProductCartButton.click();
      } else {
      // Trigger the modal
        assemblyModal.classList.add('open');
        assemblyModalOverlay.classList.add('open');
        document.body.classList.add('modal-open'); // Adding this class to disable scrolling
      }
    });

    // Close the modal when the user clicks on the close button
    const closeModalButton = document.querySelector('.assembly-modal .close-modal');
    closeModalButton.addEventListener('click', () => {
      assemblyModal.classList.remove('open');
      assemblyModalOverlay.classList.remove('open');
      document.body.classList.remove('modal-open');
    });

    // Check the assembly box if the user click on the "Add Assembly" button on the modal
    const addAssemblyButton = document.querySelector('.assembly-modal .add-assembly');
    addAssemblyButton.addEventListener('click', () => {
      assemblyCheckbox.checked = true;
      assemblyProductCartButton.click();
      assemblyModal.classList.remove('open');
      assemblyModalOverlay.classList.remove('open');
      document.body.classList.remove('modal-open');
    });

    // Just close the modal when the user clicks on the "No, thanks" button
    const noAssemblyButton = document.querySelector('.assembly-modal .no-assembly');
    noAssemblyButton.addEventListener('click', () => {
      assemblyModal.classList.remove('open');
      assemblyModalOverlay.classList.remove('open');
      document.body.classList.remove('modal-open');
    });
  })();
}, false);
